import { FC } from "react";
// import { useNavigate } from "@tanstack/react-router";

const DefaultErrorComponent: FC<{ error: unknown }> = ({ error }) => {
  const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';

  const handleGoBack = () => {
    window.history.back();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="w-full max-w-md bg-red-50 border border-red-200 rounded-xl shadow p-10 flex flex-col items-center">
        <div className="mb-4">
          <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="#f87171" strokeWidth="2" fill="#fee2e2" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01" stroke="#ef4444" strokeWidth="2" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-red-700 mb-3 text-center">Something went wrong</h1>
        <p className="text-base text-red-600 mb-7 text-center">{errorMessage}</p>
        <div className="flex gap-4 w-full justify-center">
          <button
            onClick={handleGoBack}
            className="px-5 py-2 text-base border border-red-200 rounded bg-white text-red-700 hover:bg-red-100 transition flex items-center gap-2 font-medium"
          >
            <svg className="w-5 h-5" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            Go Back
          </button>
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2 text-base border border-red-200 rounded bg-white text-red-700 hover:bg-red-100 transition flex items-center gap-2 font-medium"
          >
            <svg className="w-5 h-5" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582M20 20v-5h-.581M19.418 15A7.974 7.974 0 0012 8c-1.657 0-3.203.507-4.418 1.382M4.582 9A7.974 7.974 0 0112 16c1.657 0 3.203-.507 4.418-1.382" />
            </svg>
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};

export default DefaultErrorComponent;